var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLlamaBw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1536.917,
    height: 653.344,
    viewBox: "0 0 406.643 172.864",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#98f1ff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.34672943,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M-.209 188.114h406.891v143.585H-.209z",
    transform: "translate(-.023 -188.584)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ccd74",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: ".17964531px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m-.182 319.696 40.96-4.447c50.094-6.436 77.24-1.067 105.996 4.45 52.447 9.43 103.696 10.715 153.18.003 39.134-9.01 72.864-4.226 106.812.002l.305 41.886-407.095-.057c-.024-14.261-.158-27.575-.158-41.837z",
    transform: "translate(-.023 -188.584)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#e3d7a6",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.55850095,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M61.306 242.084c1.052-11.131 1.93-22.285 3.091-33.402 1.037-5.876 2.088-11.706 3.242-17.541 1.21-3.534 2.77-6.495 4.99-8.892 1.87-1.667 3.85-3.23 6.33-3.783.163-3.156-.615-6.595 1.21-9.405.987-1.742 1.9-3.546 3.65-4.646 1.38-1.33 3.371-2.116 5.288-1.963 1.725.613 1.686 3.16.722 4.435-.74 1.055-1.359 2.152-.994 3.492 3.062-2.465 6.002-5.186 9.138-7.494 1.303-.536 2.793-.027 2.759 1.546-.184 2.499-2.393 4.002-3.78 5.893-2.292 2.622-4.403 5.408-6.848 7.892 1.901 1.205 4.254.512 6.38.77 2.727.153 5.34 1.01 7.473 1.981 1.704.846 3.387 2.487 5.173 3.133 5.278 1.347 10.831 2.219 15.523 5.148 1.493.729 2.437 1.943 3.419 2.856.603.723 1.652 1.456 2.44 3.07.147.346-.29.566-.314.819-.09.905.773 1.254 1.75 2.864.436 1.154-.333 2.102-.556 2.727-.586 1.648-2.424 2.648-3.679 3.287-.825 2.073-2.039 3.104-4.234 2.46-2.446-.212-4.893-.428-7.287.264-3.881.57-8.358 2.664-11.118 4.05-.235.118-.503.13-.712.236-1.524.357-2.396 1.105-3.078 2.41-1.563 2.161-3.33 4.197-4.169 6.777-.806 1.942-1.235 4.083-1.493 6.159-.133 3.82-.101 7.634.456 11.424.163 1.594.353 3.186.528 4.779h-35.62z",
    transform: "translate(-19.132 -70.37)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "none",
      strokeWidth: ".12684125px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "M116.192 207.595c-3.047-.314-4.926-2.176-4.37-3.733.805-2.265 1.889-3.804 1.889-3.804.622-1.994.737-3.771 1.48-5.744.314-.83 1.652-2.03 2.57-2.755 1.484-1.932 3.685-1.85 5.256-3.265",
    transform: "translate(-19.132 -70.37)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#a16c14",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.55850095,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M61.306 242.084c1.052-11.131 1.93-22.285 3.091-33.402 1.037-5.876 2.088-11.706 3.242-17.541.569-1.661-1.39-4.944 1.97-5.148 1.441-.087-2.777-4.06 2.658-3.97-.204-3.017 2.414-2.516 3.461-2.447.627.042.423-.827.805-1.118 1.355-1.028 1.659.18 2.427.007.162-3.155-.616-6.594 1.21-9.405.986-1.741 1.9-3.545 3.649-4.645 1.38-1.33 3.371-2.116 5.288-1.963 1.725.613 1.686 3.16.722 4.435-.74 1.055-1.359 2.152-.994 3.492 3.062-2.465 6.002-5.186 9.138-7.494 1.303-.536 2.793-.027 2.759 1.546-.184 2.499-2.393 4.002-3.78 5.893-2.292 2.621-4.403 5.408-6.848 7.892 1.901 1.205 4.254.512 6.38.77 2.727.153-6.982 4.27-4.849 5.243-2.283 2.476-2.954 6.201-1.17 6.847-1.616 6.46-8.244 9.034 1.29 16.673-3.224-1.875 3.756 4.116 3.547 4.222-1.524.358 6.664 1.015 5.982 2.32-1.563 2.161-3.33 4.196-4.169 6.777-.806 1.942-1.235 4.083-1.493 6.159-.133 3.82-.101 7.634.456 11.424.163 1.594.353 3.185.528 4.779h-35.62z",
    transform: "translate(-19.132 -70.37)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#e3d7a6",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.174981,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M84.966 184.757c-1.403-1.086-2.042-2.908-2.896-4.534-.408-.839-.848-1.64-1.038-2.613-.212-1.035-.569-2.094-.52-3.15.08-1.588.556-3.131.983-4.522.621-1.176.752-1.6 1.252-2.179 1.183-1.465 3.421-3.48 4.335-3.497.856.037 1.079.699 1.079.699.132.814-.258 2.054-.828 3.18-.752 2.26-.712 5.64-1.107 8.21-.167 1.076-.492 2.133-.578 3.218.092.986.48 1.953.45 2.952.025.92-.2 2.212-1.132 2.236z",
    transform: "translate(-19.132 -70.37)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#b7b093",
      fillOpacity: 0.45273635,
      stroke: "none",
      strokeWidth: 0.20944554,
      strokeLinecap: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M128.34 204.463c0-.177-1.426-.477-4.324-.91-3.072-.457-5.158-.882-7.393-1.684-1.22-.437-2.012-.799-2.502-1.293l-.315-.51.125-.434a55.86 55.86 0 0 0 .48-2.036c.404-1.826.667-2.777.922-3.33.225-.49.764-1.125 1.54-1.814a52.05 52.05 0 0 0 1.217-1.129c.76-.732 1.32-1.083 2.62-1.636 1.084-.461 1.651-.76 2.121-1.117l.289-.22 1.12.642c.617.353 1.323.796 1.57.984.92.7 3.594 3.447 4.157 4.27l.385.566-.304.105c-.97.233-2.291-.058-3.194-.777-.447-.355-.507-.47-.638-.388a.227.227 0 0 0-.107.165c-.047.313 1.42 1.13 2.333 1.35.232.056.623.183.911.183.289 0 .635-.131.635-.105 0 .027-.093.39-.13.614-.077.482.002 1.155.202 1.762.147.442.2.53.387.393.112-.083.097.005-.036-.45-.076-.26-.18-.62-.203-.779v-.498l.25.473c.116.158.39.509.61.778.219.27.524.674.677.897l.279.407.083.64-.083.641-.436.957c-.191.421-.317.81-.489 1.11-.405.708-.876 1.106-1.702 1.61-.732.502-1.057.675-1.057.563z",
    transform: "translate(-19.132 -70.37)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#b7b093",
      fillOpacity: 0.45273635,
      stroke: "none",
      strokeWidth: 0.20944554,
      strokeLinecap: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M115.664 207.426c-1.905-.376-3.299-1.275-3.72-2.4-.226-.606-.17-.907.422-2.268.27-.62 1.062-2.04 1.174-2.167.01-.01.095.216.31.426.75.734 2.824 1.542 5.553 2.23 1.58.4 2.452.558 4.723.9 1.072.162 2.209.318 2.545.39.337.071.695.174.793.195.097.02.254.024.271.052.047.075-.296.762-.602 1.246-.304.48-.832 1.007-1.2 1.194-.576.294-1.356.359-2.177.181-1.188-.257-4.58-.34-5.922-.144-.406.059-.896.15-1.09.201-.41.11-.321.114-1.08-.036z",
    transform: "translate(-19.132 -70.37)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.55850095,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M128.258 204.679c-3.143-.905-5.258-.649-9.934-1.994-5.268-1.516-4.613-2.627-4.613-2.627",
    transform: "translate(-19.132 -70.37)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.46262097,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M130.368 195.029c-2.178.737-4.068-1.121-4.068-1.121",
    transform: "translate(-19.132 -70.37)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.41468099,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M130.368 195.029c-.794 1.248-.016 2.979-.016 2.979",
    transform: "translate(-19.132 -70.37)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.55850095,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M98.496 191.441s.866 2.516 4.5 2.419c2.98-.08 4.517-3.3 4.517-3.3",
    transform: "translate(-19.132 -70.37)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.46262097,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m99.136 192.434-1.12 1.186m2.129-.257-.64 1.394m2.21-.753-.288 1.361m2.05-1.329.064 1.265m1.826-2.001.592 1.152m2.002-1.457-1.217-.945",
    transform: "translate(-19.132 -70.37)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19.132 -70.37)",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    ry: 1.547,
    rx: 2.289,
    cy: 174.486,
    cx: 121.533,
    style: {
      display: "inline",
      fill: "#dadada",
      fillOpacity: 0.98431373,
      stroke: "none",
      strokeWidth: 0.11421321,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 1.697,
    rx: 2.894,
    cy: 169.444,
    cx: 137.755,
    style: {
      display: "inline",
      fill: "#dadada",
      fillOpacity: 0.98431373,
      stroke: "none",
      strokeWidth: 0.13451333,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    ry: 2.615,
    rx: 4.205,
    cy: 164.189,
    cx: 155.388,
    style: {
      display: "inline",
      fill: "#dadada",
      fillOpacity: 0.98431373,
      stroke: "none",
      strokeWidth: 0.20126083,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.007 150.918a4.205 2.615 0 0 0-4.087 2.013 4.205 2.615 0 0 0-1.884-.28 4.205 2.615 0 0 0-4.205 2.614 4.205 2.615 0 0 0 .433 1.153 4.205 2.615 0 0 0-1.628 2.065 4.205 2.615 0 0 0 4.175 2.613 7.788 4.842 0 0 0 .22.156 4.205 2.615 0 0 0-.016.2 4.205 2.615 0 0 0 4.206 2.615 4.205 2.615 0 0 0 3.858-1.577 7.788 4.842 0 0 0 5.354-4.593 7.788 4.842 0 0 0 0-.013 4.205 2.615 0 0 0 1.76-2.124 4.205 2.615 0 0 0-4.03-2.609 4.205 2.615 0 0 0-4.156-2.233z",
    style: {
      display: "inline",
      fill: "#dadada",
      fillOpacity: 0.98431373,
      stroke: "none",
      strokeWidth: 0.37272948,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.233 88.874a16.501 11.883 0 0 0-14.477 6.18 16.501 11.883 0 0 0-4.623-.483 16.501 11.883 0 0 0-15.479 7.807 16.501 11.883 0 0 0-5.47-.687 16.501 11.883 0 0 0-16.501 11.884 16.501 11.883 0 0 0 .073 1.03 16.501 11.883 0 0 0-12.704 11.55 16.501 11.883 0 0 0 3.29 7.1 16.501 11.883 0 0 0-5.447 8.803 16.501 11.883 0 0 0 7.526 9.959 14.807 11.409 0 0 0-2.108 5.834 14.807 11.409 0 0 0 11.01 11.013 14.807 11.409 0 0 0-.535 2.991 14.807 11.409 0 0 0 14.807 11.409 14.807 11.409 0 0 0 5.79-.922 14.807 11.409 0 0 0 13.926 7.568 14.807 11.409 0 0 0 3.522-.34 14.807 11.409 0 0 0 .593.258 11.11 8.56 0 0 0 11.107 8.5 11.11 8.56 0 0 0 10.81-6.62 11.11 8.56 0 0 0 10.447 5.671 11.11 8.56 0 0 0 10.978-7.316 11.11 8.56 0 0 0 6.89 1.857 11.11 8.56 0 0 0 11.036-7.611 11.11 8.56 0 0 0 7.536-2.7 16.501 11.883 0 0 0 8.076 1.528 16.501 11.883 0 0 0 16.501-11.883 16.501 11.883 0 0 0-.896-3.818 11.11 8.56 0 0 0 7.366-8.05 11.11 8.56 0 0 0-1.563-4.359 11.11 8.56 0 0 0 7.108-7.984 11.11 8.56 0 0 0-.11-1.122 16.501 11.883 0 0 0 6.271-9.322 16.501 11.883 0 0 0-15.113-11.833 11.11 8.56 0 0 0 .018-.273 11.11 8.56 0 0 0-8.87-8.383 11.11 8.56 0 0 0-10.866-6.823 11.11 8.56 0 0 0-2.635.254 16.501 11.883 0 0 0-16.003-9.037 16.501 11.883 0 0 0-2.31.13 16.501 11.883 0 0 0-15.558-7.963 16.501 11.883 0 0 0-9.226 2.044 16.501 11.883 0 0 0-14.187-5.841z",
    style: {
      display: "inline",
      fill: "#dadada",
      fillOpacity: 0.98507457,
      stroke: "none",
      strokeWidth: 0.78887564,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      display: "inline",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.11421321,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    cx: 121.305,
    cy: 173.892,
    rx: 2.289,
    ry: 1.547
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      display: "inline",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.13451333,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    cx: 137.527,
    cy: 168.85,
    rx: 2.894,
    ry: 1.697
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      display: "inline",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.20126083,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    cx: 155.16,
    cy: 163.595,
    rx: 4.205,
    ry: 2.615
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.37272948,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M179.358 150.345a4.205 2.615 0 0 0-4.088 2.012 4.205 2.615 0 0 0-1.884-.28 4.205 2.615 0 0 0-4.205 2.614 4.205 2.615 0 0 0 .434 1.153 4.205 2.615 0 0 0-1.628 2.065 4.205 2.615 0 0 0 4.175 2.614 7.788 4.842 0 0 0 .22.156 4.205 2.615 0 0 0-.016.2 4.205 2.615 0 0 0 4.205 2.614 4.205 2.615 0 0 0 3.859-1.576 7.788 4.842 0 0 0 5.353-4.593 7.788 4.842 0 0 0 0-.014 4.205 2.615 0 0 0 1.76-2.124 4.205 2.615 0 0 0-4.029-2.609 4.205 2.615 0 0 0-4.156-2.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.78887564,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M271.844 87.06a16.501 11.883 0 0 0-14.476 6.18 16.501 11.883 0 0 0-4.624-.484 16.501 11.883 0 0 0-15.478 7.808 16.501 11.883 0 0 0-5.47-.687 16.501 11.883 0 0 0-16.502 11.884 16.501 11.883 0 0 0 .074 1.03 16.501 11.883 0 0 0-12.704 11.55 16.501 11.883 0 0 0 3.29 7.1 16.501 11.883 0 0 0-5.447 8.803 16.501 11.883 0 0 0 7.526 9.959 14.807 11.409 0 0 0-2.108 5.834 14.807 11.409 0 0 0 11.01 11.013 14.807 11.409 0 0 0-.536 2.991 14.807 11.409 0 0 0 14.807 11.409 14.807 11.409 0 0 0 5.79-.922 14.807 11.409 0 0 0 13.927 7.568 14.807 11.409 0 0 0 3.521-.34 14.807 11.409 0 0 0 .594.258 11.11 8.56 0 0 0 11.107 8.5 11.11 8.56 0 0 0 10.81-6.62 11.11 8.56 0 0 0 10.447 5.671 11.11 8.56 0 0 0 10.978-7.316 11.11 8.56 0 0 0 6.89 1.857 11.11 8.56 0 0 0 11.036-7.611 11.11 8.56 0 0 0 7.535-2.7 16.501 11.883 0 0 0 8.077 1.528 16.501 11.883 0 0 0 16.5-11.883 16.501 11.883 0 0 0-.895-3.818 11.11 8.56 0 0 0 7.365-8.05 11.11 8.56 0 0 0-1.562-4.359 11.11 8.56 0 0 0 7.107-7.984 11.11 8.56 0 0 0-.109-1.122 16.501 11.883 0 0 0 6.27-9.322 16.501 11.883 0 0 0-15.112-11.833 11.11 8.56 0 0 0 .018-.273 11.11 8.56 0 0 0-8.87-8.383 11.11 8.56 0 0 0-10.867-6.823 11.11 8.56 0 0 0-2.634.254 16.501 11.883 0 0 0-16.004-9.037 16.501 11.883 0 0 0-2.31.13 16.501 11.883 0 0 0-15.557-7.963 16.501 11.883 0 0 0-9.227 2.044 16.501 11.883 0 0 0-14.187-5.841z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    },
    transform: "translate(-.023 -55.824)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#161616",
      strokeWidth: 0.82200003,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M199.22 105.44h29.803v37.237H199.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 0.84079602,
      stroke: "#161616",
      strokeWidth: 0.79318511,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M198.947 110.26h30.456"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#161616",
      strokeWidth: 0.13871573,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    cx: 201.965,
    cy: 108.075,
    r: 0.775
  }), /*#__PURE__*/React.createElement("circle", {
    r: 0.775,
    cy: 108.075,
    cx: 204.662,
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#161616",
      strokeWidth: 0.13871573,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#161616",
      strokeWidth: 0.13871573,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    cx: 207.358,
    cy: 108.075,
    r: 0.775
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "12.56318092px",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      display: "inline",
      fill: "none",
      fillOpacity: 1,
      stroke: "#161616",
      strokeWidth: 0.31407952,
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m218.622 134.359 4.46 1.834-.327.967-5.427-2.299v-1.005l5.427-2.299.327.967zm6.024 6.081h-1.194l4.259-12.162h1.168zm4.607-7.916.327-.967 5.427 2.3v1.004l-5.427 2.3-.327-.968 4.46-1.834z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontFamily: "Ubuntu",
      InkscapeFontSpecification: "Ubuntu",
      fill: "none",
      fillOpacity: 1,
      stroke: "#161616",
      strokeWidth: 0.31407952,
      strokeOpacity: 1
    },
    transform: "translate(-99.609 -61.584) scale(1.38716)",
    "aria-label": "</>"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M238.962 93.26a38.574 38.574 0 0 0-.788-.087c-2.608-.269-4.97-1.197-5.391-2.12-.387-.846.63-1.72 2.721-2.339 1.469-.435 3.146-.64 5.2-.637 2.747.004 5.049.422 6.58 1.195 1.47.743 1.732 1.59.732 2.37-.906.708-2.436 1.205-4.652 1.513-.651.09-3.941.169-4.402.105z",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.02165443,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(5.027 -2.117)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.48 97.202c-1.013-.057-2.425-.236-3.245-.41-1.689-.36-3.052-1.068-3.46-1.797l-.142-.253.015-1.606.015-1.606.307.241c.623.49 1.76.959 3.059 1.26 4.396 1.024 10.204.404 12.374-1.32l.297-.236v1.552c0 1.503-.004 1.56-.133 1.85-.461 1.034-2.334 1.85-5.014 2.183-.685.085-2.681.217-3.027.2l-1.046-.058z",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.02186014,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(5.027 -2.117)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.943 105.236c-2.875-.236-4.89-.86-5.804-1.798-.425-.435-.417-.389-.4-2.188l.015-1.602.334.263c1.354 1.068 4.23 1.711 7.647 1.711 3.485 0 6.258-.652 7.593-1.785l.304-.259v1.563c-.003 1.816-.01 1.855-.533 2.38-.893.893-2.914 1.507-5.654 1.719-.898.069-2.636.067-3.5-.003z",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.02161098,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(5.027 -2.117)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.23 101.255c-2.912-.201-5.027-.82-6-1.753-.492-.473-.487-.452-.487-2.322v-1.627l.256.237c1.37 1.268 5.485 2.05 9.307 1.769 2.859-.21 4.781-.76 5.95-1.7l.37-.299v1.514c0 .923-.024 1.606-.062 1.748-.098.371-.747 1.008-1.336 1.31-1.728.888-4.922 1.337-7.997 1.123z",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.02166511,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(5.027 -2.117)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.804 90.663a8.132 2.763 0 0 1-8.132 2.763 8.132 2.763 0 0 1-8.132-2.763 8.132 2.763 0 0 1 8.132-2.763 8.132 2.763 0 0 1 8.132 2.763z",
    style: {
      display: "inline",
      fill: "none",
      fillOpacity: 0.84079602,
      stroke: "#161616",
      strokeWidth: 0.47307491,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(5.027 -2.117)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.546 98.775c-.007.182.432 2.521 8.183 2.675 8.067-.14 8.075-2.753 8.075-2.753m-16.258 4.09c-.007.182.432 2.521 8.183 2.675 8.067-.14 8.075-2.753 8.075-2.753m-16.258-7.946c-.007.182.432 2.521 8.183 2.675 8.067-.14 8.075-2.753 8.075-2.753m-16.258 8.102V90.568m16.258 12.142V90.49",
    style: {
      fill: "none",
      fillOpacity: 0.84079602,
      stroke: "#161616",
      strokeWidth: 0.47307494,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(5.027 -2.117)"
  })), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-76.328 41.657) scale(.33226)",
    d: "M1112.406 147.697a20.112 20.112 0 0 0-19.383 14.828c-.81-.152-1.632-.23-2.457-.232-7.453 0-13.493 6.041-13.494 13.494 0 2.132.509 4.18 1.39 6.026h-43.218v18.935h86.213v-11.033h13.711c7.792-.49 13.86-7.515 13.861-15.322 0-8.17-6.624-14.79-14.793-14.79a14.72 14.72 0 0 0-3.318.395 20.111 20.111 0 0 0-18.512-12.3z",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#050101",
      strokeWidth: 1.02803147,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.93 103.929h22.811v5.01h-22.81z",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#161616",
      strokeWidth: 0.27165729,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-76.356 -28.447) scale(1.2558)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#161616",
      strokeWidth: 0.27165729,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M275.326 105.768h3.919v1.131h-3.919zm4.787 0h3.919v1.131h-3.919zm13.721 0h1.67v1.131h-1.67zm-19.903 4.63h22.81v5.01h-22.81z",
    transform: "translate(-76.356 -28.447) scale(1.2558)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#161616",
      strokeWidth: 0.27165729,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M275.326 112.237h3.919v1.131h-3.919zm4.787 0h3.919v1.131h-3.919zm13.721 0h1.67v1.131h-1.67z",
    transform: "translate(-76.356 -28.447) scale(1.2558)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.336 108.965v1.386m0 5.083v5.121",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.63160318,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-76.356 -28.447) scale(1.2558)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.63121885,
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M284.03 119.598h2.611v2.611h-2.611z",
    transform: "translate(-76.356 -28.447) scale(1.2558)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.918 120.904h24.836",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.63160318,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-76.356 -28.447) scale(1.2558)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.62543911,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M237.347 140.542h32.566v20.249h-32.566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010101",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.62543899,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M249.792 162.691h7.676v3.986h-7.676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010101",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.62920111,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M237.347 160.791h32.566v1.651h-32.566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010101",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.67190766,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M244.095 166.699h19.069v1.852h-19.069z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.66500002,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M235.211 172.423h6.984v5.179h-6.984z",
    transform: "translate(17.664 -18.88) scale(.94051)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.66499996,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M235.27 179.093h21.267v2.276H235.27zm0 3.375h21.267v2.276H235.27zm0 3.374h21.267v2.276H235.27z",
    transform: "translate(17.664 -18.88) scale(.94051)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.68559408,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M243.907 172.457h12.585v5.12h-12.585z",
    transform: "translate(17.664 -18.88) scale(.94051)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.74663067,
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M258.59 172.543h7.939v15.503h-7.939z",
    transform: "translate(17.664 -18.88) scale(.94051)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000",
      strokeWidth: 0.31999999,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M307.57 134.404h3.427v3.427h-3.427zm0 11.112h3.427v3.427h-3.427zm6.981 0h3.427v3.427h-3.427zm-13.962 0h3.427v3.427h-3.427z",
    transform: "translate(-218.429 -87.98) scale(1.66312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.284 137.855v7.648",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.31997111,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-218.429 -87.98) scale(1.66312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.37 145.534v-3.208",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.31933093,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-218.429 -87.98) scale(1.66312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.197 145.597v-3.271",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.31979948,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-218.429 -87.98) scale(1.66312)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.465 142.486h13.575",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.31997111,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-218.429 -87.98) scale(1.66312)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#010101",
      strokeWidth: 0.5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M239.466 113.027h20.811v15.11h-20.811z",
    transform: "translate(-1.058 1.587)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.53 121.699c2.084 3.011 6.764 3.011 8.794 0m-8.794 0-6.064-8.672m14.858 8.672 5.953-8.672m-20.811 15.109 6.063-6.437m14.748 6.437-5.953-6.437",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 0.5,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-1.058 1.587)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-372.747 -2.894) scale(2.09478)",
    style: {
      display: "inline",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.446 58.332a7.913 7.913 0 0 0-5.764 2.444l.691.663a6.957 6.957 0 0 1 10.11.055l.699-.655a7.911 7.911 0 0 0-5.736-2.507z",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      vectorEffect: "none",
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#010101",
      strokeWidth: 0.29258832,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.425 60.15a6.095 6.095 0 0 0-4.47 1.925l.699.655a5.14 5.14 0 0 1 7.525.028l.704-.65a6.1 6.1 0 0 0-4.458-1.958z",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      vectorEffect: "none",
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#010101",
      strokeWidth: 0.29258832,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.436 62.132a4.115 4.115 0 0 0-3.076 1.346l.71.644a3.154 3.154 0 0 1 4.702.039l.719-.634a4.116 4.116 0 0 0-3.055-1.395z",
    style: {
      color: "#000",
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: "normal",
      fontFamily: "sans-serif",
      fontVariantLigatures: "normal",
      fontVariantPosition: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantAlternates: "normal",
      fontFeatureSettings: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecoration: "none",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#000",
      letterSpacing: "normal",
      wordSpacing: "normal",
      textTransform: "none",
      writingMode: "lr-tb",
      direction: "ltr",
      textOrientation: "mixed",
      dominantBaseline: "auto",
      baselineShift: "baseline",
      textAnchor: "start",
      whiteSpace: "normal",
      shapePadding: 0,
      clipRule: "nonzero",
      display: "inline",
      overflow: "visible",
      visibility: "visible",
      opacity: 1,
      isolation: "auto",
      mixBlendMode: "normal",
      colorInterpolation: "sRGB",
      colorInterpolationFilters: "linearRGB",
      solidColor: "#000",
      solidOpacity: 1,
      vectorEffect: "none",
      fill: "none",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#010101",
      strokeWidth: 0.29258832,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      colorRendering: "auto",
      imageRendering: "auto",
      shapeRendering: "auto",
      textRendering: "auto",
      enableBackground: "accumulate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    r: 1.596,
    cy: 66.246,
    cx: 331.403,
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#010101",
      strokeWidth: 0.29258832,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLlamaBw);
export default __webpack_public_path__ + "static/media/llamaBW.01d3d643f0fbdafe12c45682e0810184.svg";
export { ForwardRef as ReactComponent };